import { Component } from '@angular/core';

@Component({
  selector: 'app-rightsidebar',
  templateUrl: './rightsidebar.component.html'
})
export class RightSidebarComponent {
  constructor() {}
}
